import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "onChange", "onBlur", "defaultValue", "min", "max", "decimalDigits", "maxLength", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { formatBigNumber } from '../../../../internal/utils/formatBigNumber';
import { IMaskInput } from '../../../../internal/components/IMaskInput';
import { THOUSAND_DELIMITER, FRACTIONAL_DELIMITER } from '../../../../internal/constants/number';
import { jsx as _jsx } from "react/jsx-runtime";
export var NativeNumberInput = /*#__PURE__*/React.forwardRef(function NativeNumberInput(props, ref) {
  var as = props.as,
    onChange = props.onChange,
    onBlur = props.onBlur,
    defaultValue = props.defaultValue,
    min = props.min,
    max = props.max,
    _props$decimalDigits = props.decimalDigits,
    decimalDigits = _props$decimalDigits === void 0 ? 0 : _props$decimalDigits,
    maxLength = props.maxLength,
    value = props.value,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(toStringInputValue(value || defaultValue)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var _React$useState3 = React.useState(maxLength),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    inputMaxLength = _React$useState4[0],
    setInputMaxLength = _React$useState4[1];
  var options = React.useMemo(function () {
    return {
      mask: Number,
      thousandsSeparator: THOUSAND_DELIMITER,
      radix: FRACTIONAL_DELIMITER,
      signed: isSignedRange(min),
      scale: decimalDigits
    };
  }, [min, decimalDigits]);
  var handleInputAccept = function handleInputAccept(eventValue, mask) {
    var nextValue = toNumberValue(eventValue, min, max);
    setInputValue(eventValue);
    if (maxLength) {
      /**
       * maxLength не учитывает разделители, добавляемые маской.
       * Из-за этого вводимое число может укладываться в maxLength, а value с разделителями - нет, поэтому ввод не проходит.
       *
       * Например:
       *
       * maxLength = 5, хотим ввести число 10000, маска добавляет разделитель, получаем 10 000.
       * И при вводе такого числа получится ввести только 1000.
       *
       * Добавляя разделители к maxLength, мы покрываем этот кейс
       */
      var separatorsCount = getSeparatorsCount(mask.value, options.thousandsSeparator);
      setInputMaxLength(maxLength + separatorsCount);
    }

    /**
     * nextValue - значение с учетом min и max, т.е. если будет введено value 100, а max = 99, то nextValue будет 99
     * onChange надо вызывать в том случае, если вводимое число eventValue попадает в диапазон min и max и равно nextValue
     * Иначе при вводе числа, не попадающего в интервал в инпуте, его значение резко будет заменено на nextValue
     */
    if (onChange && nextValue !== value && toNumberValue(eventValue) === nextValue) {
      onChange(nextValue);
    }
  };
  var handleBlur = function handleBlur(e) {
    if (onBlur) {
      onBlur(e);
    }
    var finalValue = toNumberValue(inputValue, min, max);
    setInputValue(toStringInputValue(finalValue));
    if (onChange && toNumberValue(inputValue) !== finalValue) {
      onChange(finalValue);
    }
  };
  React.useEffect(function () {
    setInputValue(toStringInputValue(value));
  }, [value]);
  return /*#__PURE__*/_jsx(IMaskInput, _objectSpread(_objectSpread({}, rest), {}, {
    maxLength: inputMaxLength,
    ref: ref,
    as: as,
    type: "tel",
    onBlur: handleBlur,
    value: inputValue,
    options: options,
    onAccept: handleInputAccept,
    onComplete: handleInputAccept
  }));
});
function toNumberValue(inputValue, min, max) {
  return normalizeValue(inputValue !== '' ? Number(inputValue) : undefined, min, max);
}
function normalizeValue(value, min, max) {
  if (value == null) {
    return min || value;
  }
  var nextValue = value;
  if (min != null) {
    nextValue = Math.max(min, nextValue);
  }
  if (max != null) {
    nextValue = Math.min(max, nextValue);
  }
  return nextValue;
}
function toStringInputValue(value) {
  if (typeof value === 'number') {
    return formatBigNumber(value);
  }
  return '';
}
function isSignedRange(min) {
  if (min != null) {
    return min < 0;
  }
  return true;
}
function getSeparatorsCount(value, separator) {
  var _value$match;
  return ((_value$match = value.match(new RegExp(separator, 'g'))) === null || _value$match === void 0 ? void 0 : _value$match.length) || 0;
}